var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-card"},[_c('label',[_vm._v(_vm._s(_vm.heading)+":")]),_c('div',{staticClass:"grid"},_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"grid-item"},[_c('span',[_vm._v(_vm._s(item.item_value))])])}),0),_c('button',{staticClass:"secondary-btn-dark"},[_vm._v("EDIT "+_vm._s(_vm.heading))])])
}
var staticRenderFns = []

export { render, staticRenderFns }